import { useTheme } from "../../hooks/useTheme";
import { uploadTerms, termsTitle } from "../../data/terms";

interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function TermsModal({ isOpen, onClose }: TermsModalProps) {
  const theme = useTheme(state => state.getThemeStyles());
  
  if (!isOpen) return null;

  return (
    <div className={theme.components.termsModal.wrapper}>
      <div 
        className={theme.components.termsModal.overlay}
        onClick={onClose}
      />
      
      <div className={theme.components.termsModal.container}>
        <div className={theme.components.termsModal.header.wrapper}>
          <h2 className={theme.components.termsModal.header.title}>
            {termsTitle}
          </h2>
        </div>

        <div className={theme.components.termsModal.content.wrapper}>
          {uploadTerms.map((section) => (
            <section key={section.title}>
              <h3 className={theme.components.termsModal.content.section.title}>
                {section.title}
              </h3>
              <ul className={theme.components.termsModal.content.section.list}>
                {section.items.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </section>
          ))}
        </div>

        <div className={theme.components.termsModal.footer.wrapper}>
          <button
            onClick={onClose}
            className={theme.components.termsModal.footer.button.base}
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}